// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"87bf45ea","237":"07c92d69","298":"68245784","397":"22da206b","453":"8945f81c","727":"de2588d8","766":"e892bc7b","823":"964c3229","913":"596e3fb5","920":"1079f030","982":"74ea5e50"}[chunkId] + ".chunk.js";
};